import { eTransactionType } from '../eTransactionType';
import { eTitleFees } from '../../../../ui-toolkit/enums/eTitleFees';

export interface IOtherTitleFeeConfigurationResponse {
  transactionTypes: eTransactionType[];
  titleFee: eTitleFees;
  fee: number;
}

export type IOtherTitleFeeConfigurationData = IOtherTitleFeeConfigurationResponse;

export const convertIOtherTitleFeeConfigurationResponseToIOtherTitleFeeConfigurationData = (
  response: IOtherTitleFeeConfigurationData
): IOtherTitleFeeConfigurationResponse => ({ ...response });
